// extracted by mini-css-extract-plugin
export default {"isDark":"Theme_Choose_isDark__tL8W4","isLight":"Theme_Choose_isLight__ohzPI","dark":"Theme_Choose_dark__SPOmL"};